import React from "react";
import { formatTimeToDisplay, updateIsoTime } from "../../../utils";
import { TimePickerProps } from "../../../types";
import "./TimePicker.css";

const HOURS = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
const MINUTES = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];

const TimePicker: React.FC<TimePickerProps> = ({ value = "", onChange, className = "", style }) => {
  const h24 = parseInt(value.slice(11, 13), 10);
  const min = parseInt(value.slice(14, 16), 10);
  const period = h24 >= 12 ? "PM" : "AM";
  const h12 = h24 % 12 || 12;

  const handleChange = (newH12: number, newMin: number, newPeriod: "AM" | "PM") => {
    if (onChange) {
      onChange(updateIsoTime(value, newH12, newMin, newPeriod));
    }
  };

  return (
    <div className={`custom-time-picker-container ${className}`} style={style}>
      <div className="time-picker-header">{formatTimeToDisplay(value)}</div>
      <div className="time-picker-columns">
        <div className="time-picker-column">
          {HOURS.map((h) => (
            <button
              key={h}
              type="button"
              className={`time-picker-item ${h12 === h ? "active" : ""}`}
              onClick={() => handleChange(h, min, period)}
            >
              {String(h).padStart(2, "0")}
            </button>
          ))}
        </div>
        <div className="time-picker-column">
          {MINUTES.map((m) => (
            <button
              key={m}
              type="button"
              className={`time-picker-item ${min === m ? "active" : ""}`}
              onClick={() => handleChange(h12, m, period)}
            >
              {String(m).padStart(2, "0")}
            </button>
          ))}
        </div>
        <div className="period-toggle-group">
          <button
            type="button"
            className={`period-btn ${period === "AM" ? "active" : ""}`}
            onClick={() => handleChange(h12, min, "AM")}
          >
            AM
          </button>
          <button
            type="button"
            className={`period-btn ${period === "PM" ? "active" : ""}`}
            onClick={() => handleChange(h12, min, "PM")}
          >
            PM
          </button>
        </div>
      </div>
    </div>
  );
};

export default TimePicker;
